var CACHE_KEY = "device.supportHLS";
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType
var canPlayType = function (element, mediaType) {
    return (element.canPlayType(mediaType) !== '');
};
export var supportsHLS = function () {
    try {
        if (localStorage.getItem('adv-settings-video-legacy-format'))
            return false;
        if (typeof window.sessionStorage !== "undefined") {
            if (window.sessionStorage.getItem(CACHE_KEY))
                return window.sessionStorage.getItem(CACHE_KEY) === 'true';
        }
        var video = document.createElement('video');
        var canPlayH264 = !!video.canPlayType && (canPlayType(video, 'video/mp4; codecs="avc1.42E01E"') || canPlayType(video, 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'));
        var canPlayM3U8 = !!video.canPlayType && (canPlayType(video, 'application/vnd.apple.mpegURL') || canPlayType(video, 'application/x-mpegURL'));
        var supported = canPlayH264 && canPlayM3U8;
        if (typeof window.sessionStorage !== "undefined") {
            window.sessionStorage.setItem(CACHE_KEY, supported.toString());
        }
        return supported;
    }
    catch (error) {
        captureException(error);
        return false;
    }
};
